const min = -(2 ** 31) | 0;

export default min;
